import api from "../axiosIntercepture";

/**
 * Normalize get-all-menu payload. API returns { menus, tenantModuleAccess, tenant };
 * legacy callers may still receive a bare menu array.
 */
export const normalizeGetAllMenuResult = (raw) => {
  if (raw == null) {
    return { menus: [], tenantModuleAccess: [], tenant: null };
  }
  if (Array.isArray(raw)) {
    return { menus: raw, tenantModuleAccess: [], tenant: null };
  }
  return {
    menus: Array.isArray(raw.menus) ? raw.menus : [],
    tenantModuleAccess: Array.isArray(raw.tenantModuleAccess) ? raw.tenantModuleAccess : [],
    tenant: raw.tenant ?? null,
  };
};

export const getAllMenuList = async (userData) => {
  try {
    const response = await api.post("global/get-all-menu", userData ?? {});
    const raw = response.data?.data ?? response.data;
    return normalizeGetAllMenuResult(raw);
  } catch (err) {
    throw err?.response?.data?.message;
  }
};
